module.exports = __webpack_public_path__ + "static/media/trunkCurl.da1c8fe0.png";